import { useNoteOptionsPanel } from '../../pages/DashboardComponents/NoteOptionsPanel/Core/useNoteOptionsPanel';
import noteOptionsPanelEngine from '../../pages/DashboardComponents/NoteOptionsPanel/Core/NoteOptionsPanelEngine';
import { ContentPanelProvider } from '../../contexts/ContentPanelContext';
import ContentPanelInner from './ContentPanelInner';
import CreateNoteDlgWidget from '../../Widgets/CreateNoteDlgWidget/CreateNoteDlgWidget';
import { createDlgConfig } from '../../Widgets/CreateNoteDlgWidget/createNoteSchema';

const _dlgConfig = createDlgConfig();

export const typeColor = {
    State: '#4cceac',
    Session: '#66b2ff',
    Decision: '#f0a500',
    Issue: '#ff6b6b',
};

/**
 * ContentPanel — wraps ContentPanelInner with ContentPanelProvider.
 * Also mounts CreateNoteDlgWidget here so it's available in all tabs that use ContentPanel
 * (YourNotes, YourData, YourLibrary) without coupling it to ContentPanelInner.
 * @param {object} props.entry
 * @param {string} [props.panelId='default']
 */
export default function ContentPanel({ entry, panelId = 'default' }) {
    const { newNoteOpen } = useNoteOptionsPanel(panelId);

    return (
        <ContentPanelProvider>
            <ContentPanelInner entry={entry} panelId={panelId} />

            {/* CreateNoteDlgWidget — mounted here so it's available in all tabs that use ContentPanel */}
            <CreateNoteDlgWidget
                id="01"
                open={newNoteOpen}
                focusFieldId={_dlgConfig.focusFieldId}
                anchorEntry={entry}
                onClose={() => noteOptionsPanelEngine.closeNewNote(panelId)}
            />
        </ContentPanelProvider>
    );
}
